export class Countup {

    constructor()
    {
        this.countups = document.querySelectorAll('[data-countup-animation]');
        this.countups_offsets = [];
        this.intervals = [];
        this.initValues();
    }

    initValues(depth)
    {
        this.countups.forEach((e) => {
            e.innerHTML = '0';

            let offsetTop = 0;
            while (e) {
                offsetTop += e.offsetTop;
                e = e.offsetParent;
            }

            const animation_init_position = offsetTop;
            this.countups_offsets.push(animation_init_position);
        });
    }

    onScroll(depth,w,y)
    {
        for (let i = 0; i < this.countups_offsets.length; i++) {
            let offset = depth + y;
            if (offset >= this.countups_offsets[i]) {
                this.animateCountUp(i);
            }
        }
    }

    animateCountUp(item)
    {
        const elem = this.countups[item];
        if (elem.dataset.countupCurrent > 0) {
            return false;
        }

        elem.dataset.countupCurrent = 1;

        const time = elem.dataset.countupAnimation;

        // How long you want the animation to take, in ms
        const animationDuration = elem.dataset.countupAnimation;
        // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
        const frameDuration = 1000 / 60;
        // Use that to calculate how many frames we need to complete the animation
        const totalFrames = Math.round( animationDuration / frameDuration );
        // An ease-out function that slows the count as it progresses
        const easeOutQuad = t => t * ( 2 - t );

      let frame = 0;
      const countTo = parseInt(  elem.dataset.countupFinish, 10 );
      // Start the animation running 60 times per second
      const counter = setInterval( () => {
        frame++;
        // Calculate our progress as a value between 0 and 1
        // Pass that value to our easing function to get our
        // progress on a curve
        const progress = easeOutQuad( frame / totalFrames );
        // Use the progress value to calculate the current count
        const currentCount = Math.round( countTo * progress );

        // If the current count has changed, update the element
        if ( parseInt( elem.innerHTML, 10 ) !== currentCount ) {
          elem.innerHTML = currentCount;
        }

        // If we’ve reached our last frame, stop the animation
        if ( frame === totalFrames ) {
          clearInterval( counter );
        }
      }, frameDuration );

    }

}
